'use client';

import { useEffect } from 'react';
import type { InitType } from '@intercom/messenger-js-sdk/types';

export type IntercomChatbotProps = {
    config: InitType;
};

export const IntercomChatbot = ({ config }: IntercomChatbotProps) => {
    useEffect(() => {
        if (!config.app_id || !config.api_base) {
            return;
        }

        const load = async () => {
            const { Intercom } = await import('@intercom/messenger-js-sdk');
            Intercom(config);
        };

        if ('requestIdleCallback' in window) {
            requestIdleCallback(load, { timeout: 5000 });
        } else {
            setTimeout(load, 1000);
        }
    }, [config]);

    return null;
};
